import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRootState} from "../../store/store";
import {closeFlowVariantB, setLastAuthActionVariantB} from "../state/registration_flow_variantB_slice";
import {AuthActionType} from "../types/AuthActionType";
import {AuthModalVariant, getAuthModalHeaderContent} from "./auth_modal/AuthModalHeaderVariants";
import {AuthCard} from "./AuthCard";

export const AuthModalVariantB = () => {
    const dispatch = useDispatch();
    const flowState = useSelector((state: IRootState) => state.registrationFlowVariantB);

    const onAuthSuccess = (authActionType: AuthActionType) => {
        if (flowState.registrationSuccessCallback && authActionType === AuthActionType.REGISTRATION) {
            flowState.registrationSuccessCallback();
        }
        dispatch(setLastAuthActionVariantB({authAction: authActionType}));
    };

    const onClose = () => {
        dispatch(closeFlowVariantB());
    };

    if (!flowState.isActive || !flowState.userSource) {
        return null;
    }

    const headerContent = getAuthModalHeaderContent(flowState.titleVariant || AuthModalVariant.HIDDEN_PRICES_VARIANT_B);

    return (
        <Modal isOpen shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} onModalClose={onClose} className={modalStyle}>
            <div className={modalContentStyle} data-testid={OFFER_TEST_IDS.OFFER_VIEW.REGISTER_FORM_MODAL}>
                <div className={modalContentAuthCardWrapperStyle}>
                    <div className={closeButtonStyle} onClick={onClose}>
                        <CloseIcon size="1.6" />
                    </div>
                    <AuthCard
                        onAuthSuccess={onAuthSuccess}
                        userSource={flowState.userSource}
                        gtmSourceSection={flowState.gtmSourceSection}
                        modalTitle={
                            <div className={headerSectionStyle}>
                                <Text align="center" variant="headline_3" className={headerTitleTextStyle}>
                                    {headerContent.title}
                                </Text>
                            </div>
                        }
                        modalDescription={null}
                        className={authCardStyle}
                        wrapperClassName={authCardWrapperStyle}
                        variant={flowState.modalVariant}
                        showLoginForm={flowState.showLoginForm}
                    />
                </div>
            </div>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "544px",
    sm: {
        borderRadius: 2
    }
});

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    md: {
        alignItems: "flex-start",
        flexDirection: "row-reverse",
        p: 2,
        maxHeight: "calc(100dvh - 8rem)",
        overflow: "auto"
    }
});

const modalContentAuthCardWrapperStyle = css({
    position: "relative"
});

const authCardStyle = css({
    flex: "0 0 55rem",
    width: "100%",
    borderRadius: 2,
    boxShadow: "4",
    background: "white",
    "@media (min-width: 768px)": {
        width: "auto"
    },
    md: {
        maxWidth: "544px"
    }
});

const authCardWrapperStyle = css({
    padding: 0,
    md: {
        padding: 1,
        width: "auto"
    }
});

const headerSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginBottom: 3,
    paddingRight: 3
});

const headerTitleTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const closeButtonStyle = css({
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: "calc(-0.5 * var(--globals-baseUnit))",
    marginRight: "calc(-0.5 * var(--globals-baseUnit))",
    zIndex: 10,
    backgroundColor: "white",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    md: {
        marginTop: "calc(-1.5 * var(--globals-baseUnit))",
        marginRight: "calc(-1.5 * var(--globals-baseUnit))"
    },

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRootState} from "../../store/store";
import {closeFlowVariantB, setLastAuthActionVariantB} from "../state/registration_flow_variantB_slice";
import {AuthActionType} from "../types/AuthActionType";
import {AuthModalVariant, getAuthModalHeaderContent} from "./auth_modal/AuthModalHeaderVariants";
import {AuthCard} from "./AuthCard";

export const AuthModalVariantB = () => {
    const dispatch = useDispatch();
    const flowState = useSelector((state: IRootState) => state.registrationFlowVariantB);

    const onAuthSuccess = (authActionType: AuthActionType) => {
        if (flowState.registrationSuccessCallback && authActionType === AuthActionType.REGISTRATION) {
            flowState.registrationSuccessCallback();
        }
        dispatch(setLastAuthActionVariantB({authAction: authActionType}));
    };

    const onClose = () => {
        dispatch(closeFlowVariantB());
    };

    if (!flowState.isActive || !flowState.userSource) {
        return null;
    }

    const headerContent = getAuthModalHeaderContent(flowState.titleVariant || AuthModalVariant.HIDDEN_PRICES_VARIANT_B);

    return (
        <Modal isOpen shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} onModalClose={onClose} className={modalStyle}>
            <div className={modalContentStyle} data-testid={OFFER_TEST_IDS.OFFER_VIEW.REGISTER_FORM_MODAL}>
                <div className={modalContentAuthCardWrapperStyle}>
                    <div className={closeButtonStyle} onClick={onClose}>
                        <CloseIcon size="1.6" />
                    </div>
                    <AuthCard
                        onAuthSuccess={onAuthSuccess}
                        userSource={flowState.userSource}
                        gtmSourceSection={flowState.gtmSourceSection}
                        modalTitle={
                            <div className={headerSectionStyle}>
                                <Text align="center" variant="headline_3" className={headerTitleTextStyle}>
                                    {headerContent.title}
                                </Text>
                            </div>
                        }
                        modalDescription={null}
                        className={authCardStyle}
                        wrapperClassName={authCardWrapperStyle}
                        variant={flowState.modalVariant}
                        showLoginForm={flowState.showLoginForm}
                    />
                </div>
            </div>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "544px",
    sm: {
        borderRadius: 2
    }
});

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    md: {
        alignItems: "flex-start",
        flexDirection: "row-reverse",
        p: 2,
        maxHeight: "calc(100dvh - 8rem)",
        overflow: "auto"
    }
});

const modalContentAuthCardWrapperStyle = css({
    position: "relative"
});

const authCardStyle = css({
    flex: "0 0 55rem",
    width: "100%",
    borderRadius: 2,
    boxShadow: "4",
    background: "white",
    "@media (min-width: 768px)": {
        width: "auto"
    },
    md: {
        maxWidth: "544px"
    }
});

const authCardWrapperStyle = css({
    padding: 0,
    md: {
        padding: 1,
        width: "auto"
    }
});

const headerSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginBottom: 3,
    paddingRight: 3
});

const headerTitleTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const closeButtonStyle = css({
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: "calc(-0.5 * var(--globals-baseUnit))",
    marginRight: "calc(-0.5 * var(--globals-baseUnit))",
    zIndex: 10,
    backgroundColor: "white",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    md: {
        marginTop: "calc(-1.5 * var(--globals-baseUnit))",
        marginRight: "calc(-1.5 * var(--globals-baseUnit))"
    },

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});
